// extracted by mini-css-extract-plugin
export var active = "index-module--active--K56Wu";
export var colorBlock = "index-module--colorBlock--71IPM";
export var fill = "index-module--fill--TSGTK";
export var indicator = "index-module--indicator--X4UlU";
export var indicatorMb = "index-module--indicatorMb--BZzrV";
export var indicatorWrapper = "index-module--indicatorWrapper--CfyhF";